import React, { useEffect, useState } from 'react'
import styles from '../settingsModals.module.scss'
import Input from '../../../../UiKitComponents/Input'
import ErrorMessageComponent from '../../../../ReusableField/ErrorMessageComponent'
import Button from '../../../../UiKitComponents/Button'
import { useDispatch, useSelector } from 'react-redux'
import {
  emptyResetEmailFormValidation,
  setResetEmailFormValidation,
} from '../../../../../redux/actions/validation'
import emailValidator from '../../../../../utils/validators/emailValidator'
import {
  closeConfirmationModal,
  setConfirmationModal,
  setConfirmationModalFormErrorMessage,
} from '../../../../../redux/actions/confirmationModal'
import { upDateUserData } from '../../../../../api/userApi'
import EnterCode from '../../../../Pages/Common/EnterCode'
import {
  setUserEmail,
  setVerificationCode,
} from '../../../../../redux/actions/authActions'

const EditEmail = () => {
  const dispatch = useDispatch()

  const {
    validation: {
      resetEmailFormValidation: { emailVal },
    },
    userDetails,
  } = useSelector((state) => state)
  const { firstName, lastName, email } = userDetails
  const [errorMessage, setErrorMessage] = useState('')
  const [emailEditValue, setEmailEditValue] = useState(email)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave()
    }
  }
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [email, emailVal])
  useEffect(() => {
    return () => {
      dispatch(emptyResetEmailFormValidation())
    }
  }, [])

  const handleClick = () => {
    let inValid = !email
    if (validationEmail('email', email)) {
      inValid = true
    }
    if (inValid) {
      setErrorMessage('')
      return
    }
  }
  const handleEmailChange = (e) => {
    setErrorMessage('')
    dispatch(setResetEmailFormValidation('email' + 'Val', null))
    setEmailEditValue(e.currentTarget.value)
  }

  const handleSave = () => {
    const body = {
      emailAddress: emailEditValue,
    }
    upDateUserData(body)
      .then((res) => {
        dispatch(
          setConfirmationModal({
            headerText: 'Wir haben Ihnen eine E-Mail gesendet',
            body: <EnterCode emailEditValue={emailEditValue} />,
            large: true,
            headerBorder: true,
            modalFromSettings: true,
          }),
        )
      })
      .then(() => dispatch(setVerificationCode('')))
      .catch((err) => {
        if (err.errorCode === 'REIMBURSEMENT_ACCOUNT_UPDATE_EMAIL_ALREADY_TAKEN') {
          setErrorMessage('Das Profil wurde nicht gefunden.')
        }
      })
  }
  const validationEmail = (field, value) => {
    let inValid = false
    if (!value) {
      inValid = true
      dispatch(setResetEmailFormValidation(field + 'Val', 'E-Mail ist erforderlich'))
    } else if (!emailValidator(emailEditValue)) {
      inValid = true
      dispatch(
        setResetEmailFormValidation(field + 'Val', 'Falsche E-Mail oder Passwort'),
      )
    }
    return inValid
  }
  const handleBlurEmailField = (field, value) => {
    validationEmail(field, value)
  }

  return (
    <div className={styles.editedUserDitails}>
      <Input
        type={'email'}
        placeholder={'Email Adresse'}
        value={emailEditValue}
        onChange={handleEmailChange}
        onBlur={(e) => handleBlurEmailField('email', e.currentTarget.value)}
        validationMessage={emailVal}
        required={true}
        // autoFocus={edit === 'emailEdit'}
      />
      {errorMessage && <ErrorMessageComponent errorMessage={errorMessage} />}
      <Button
        primary
        small
        onClick={handleSave}
        disabled={!emailEditValue || emailEditValue === email}
      >
        {'Speichern'}
      </Button>
    </div>
  )
}

export default EditEmail
